import React from 'react'
import { func, object, bool } from 'prop-types'
import Select from 'react-select'
import ReactPagination from 'react-js-pagination'

const perPageOptions = [
  { value: 10, label: '10' },
  { value: 20, label: '20' },
  { value: 50, label: '50' },
  { value: 100, label: '100' },
]

const defaultPerPage = 20
const defaultPage = 1

function Pagination({
  onFiltersChange,
  filters,
  meta,
  hidePerPage = false,
}) {
  const page = filters.page || defaultPage
  const fromItemsDisplayed = page === 1 ? 1 : (filters.perPage || defaultPerPage * (page - 1)) + 1
  const toItemsDisplayed = page === 1 ? Math.min(filters.perPage || defaultPerPage, meta.totalCount)
    : Math.min(meta.totalCount, (filters.perPage || defaultPerPage * page))

  function handlePageChange(pageNumber) {
    onFiltersChange({ ...filters, page: pageNumber })
  }

  function jumpToPage(e) {
    if (e.key === 'Enter' && e.target.value > 0 && e.target.value <= meta.totalPages) {
      onFiltersChange({ ...filters, page: parseInt(e.target.value, 10) })
    }
  }

  return (
    <div className="products-pagination text-dark">
      <div className="row">
        <div className="col-12 col-md-5 products-pagination__per-page">
          {!hidePerPage && (
            <div className="form-inline u-inline-block">
              <div className="form-group">
                <label>Per page:</label>
                <Select
                  id="per-page"
                  className="Select-outline u-mr10 u-ml10"
                  options={perPageOptions}
                  onChange={(data) => onFiltersChange({ ...filters, perPage: data.value, page: 1 })}
                  value={filters.perPage}
                  searchable={false}
                  clearable={false}
                />
              </div>
            </div>
          )}
          <span>
            {`${fromItemsDisplayed} - ${toItemsDisplayed} of ${meta.totalCount} items`}
          </span>
        </div>
        <div className="col-12 col-md-7 u-text-right products-pagination__select-page">
          <div className="u-inline-block">
            <ReactPagination
              activePage={filters.page || defaultPage}
              itemsCountPerPage={filters.perPage || defaultPerPage}
              totalItemsCount={meta.totalCount}
              pageRangeDisplayed={5}
              onChange={handlePageChange}
              firstPageText="First"
              lastPageText="Last"
              innerClass="pagination--grey"
              disabledClass="is-disabled"
              activeLinkClass="is-active"
            />
          </div>
          <div className="form-inline u-inline-block">
            <div className="form-group">
              <label htmlFor="exact-page">Jump to page:</label>
              <input
                type="text"
                id="exact-page"
                placeholder={filters.page || defaultPage}
                onKeyPress={(e) => jumpToPage(e)}
                className="form-control form-control-sm u-ml10"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

Pagination.propTypes = {
  onFiltersChange: func.isRequired,
  filters: object.isRequired,
  meta: object.isRequired,
  hidePerPage: bool,
}

export default Pagination
